"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AllPublicProducts = void 0;
var _Basic = require("./asia/public/Basic");
var _Top = require("./asia/public/Top");
var _Essential = require("./asia/public/Essential");
var _Basic2 = require("./bupa/public/Basic");
var _Standard = require("./bupa/public/Standard");
var _Ultimate = require("./bupa/public/Ultimate");
var _Classic = require("./cba/public/Classic");
var _ClassicPlus = require("./cba/public/ClassicPlus");
var _Platinum = require("./guardian/public/Platinum");
var _Bronze = require("./guardian/public/Bronze");
var _Gold = require("./guardian/public/Gold");
var _Premium = require("./guidedogs/public/Premium");
var _Basic3 = require("./guidedogs/public/Basic");
var _Comprehensive = require("./guidedogs/public/Comprehensive");
var _Basic4 = require("./iag/public/Basic");
var _Indoor = require("./iag/public/Indoor");
var _Premium2 = require("./iag/public/Premium");
var _Standard2 = require("./iag/public/Standard");
var _PremiumPlus = require("./hcf/public/PremiumPlus");
var _Premium3 = require("./hcf/public/Premium");
var _Indoor2 = require("./kogan/public/Indoor");
var _Luxury = require("./kogan/public/Luxury");
var _Primary = require("./kogan/public/Primary");
var _Max = require("./medibank/public/Max");
var _Plus = require("./medibank/public/Plus");
var _Protect = require("./medibank/public/Protect");
var _Core = require("./greencross/public/Core");
var _Total = require("./greencross/public/Total");
var _Essentials = require("./pia/public/Essentials");
var _EssentialsStepDown = require("./pia/public/EssentialsStepDown");
var _Major = require("./pia/public/Major");
var _Comprehensive2 = require("./pia/public/Comprehensive");
var _Imperial = require("./prime/public/Imperial");
var _Regal = require("./prime/public/Regal");
var _Sovereign = require("./prime/public/Sovereign");
var _General = require("./rspca/public/General");
var _UltimatePlus = require("./rspca/public/UltimatePlus");
var _Economy = require("./rspca/public/Economy");
var _Ultimate2 = require("./rspca/public/Ultimate");
var _Classic2 = require("./real/public/Classic");
var _Premium4 = require("./real/public/Premium");
var _Standard3 = require("./real/public/Standard");
var _NoseToTail = require("./bwm/public/Nose-To-Tail");
var _Basic5 = require("./wow/public/Basic");
var _ComprehensivePlus = require("./wow/public/ComprehensivePlus");
var _Comprehensive3 = require("./wow/public/Comprehensive");
var _Indoor3 = require("./wow/public/Indoor");
var _Standard4 = require("./wow/public/Standard");
var _Platinum2 = require("./pinscom/public/Platinum");
var _Bronze2 = require("./pinscom/public/Bronze");
var _Silver = require("./pinscom/public/Silver");
var _Gold2 = require("./pinscom/public/Gold");
var AllPublicProducts = exports.AllPublicProducts = {
  "asia": {
    "Basic": {
      "Plan_933": _Basic.Plan_933
    },
    "Top": {
      "Plan_884": _Top.Plan_884,
      "Plan_885": _Top.Plan_885
    },
    "Essential": {
      "Plan_883": _Essential.Plan_883
    }
  },
  "bupa": {
    "Basic": {
      "Plan_748": _Basic2.Plan_748
    },
    "Standard": {
      "Plan_749": _Standard.Plan_749,
      "Plan_750": _Standard.Plan_750
    },
    "Ultimate": {
      "Plan_751": _Ultimate.Plan_751,
      "Plan_752": _Ultimate.Plan_752,
      "Plan_753": _Ultimate.Plan_753,
      "Plan_754": _Ultimate.Plan_754,
      "Plan_755": _Ultimate.Plan_755,
      "Plan_756": _Ultimate.Plan_756,
      "Plan_757": _Ultimate.Plan_757,
      "Plan_758": _Ultimate.Plan_758
    }
  },
  "cba": {
    "Classic": {
      "Plan_1008": _Classic.Plan_1008,
      "Plan_1010": _Classic.Plan_1010,
      "Plan_1012": _Classic.Plan_1012,
      "Plan_1014": _Classic.Plan_1014
    },
    "ClassicPlus": {
      "Plan_1016": _ClassicPlus.Plan_1016,
      "Plan_1018": _ClassicPlus.Plan_1018,
      "Plan_1020": _ClassicPlus.Plan_1020,
      "Plan_1022": _ClassicPlus.Plan_1022
    }
  },
  "guardian": {
    "Platinum": {
      "Plan_888": _Platinum.Plan_888,
      "Plan_889": _Platinum.Plan_889
    },
    "Bronze": {
      "Plan_934": _Bronze.Plan_934
    },
    "Gold": {
      "Plan_887": _Gold.Plan_887
    }
  },
  "guidedogs": {
    "Premium": {
      "Plan_892": _Premium.Plan_892,
      "Plan_893": _Premium.Plan_893
    },
    "Basic": {
      "Plan_890": _Basic3.Plan_890
    },
    "Comprehensive": {
      "Plan_891": _Comprehensive.Plan_891
    }
  },
  "iag": {
    "Basic": {
      "Plan_908": _Basic4.Plan_908
    },
    "Indoor": {
      "Plan_906": _Indoor.Plan_906
    },
    "Premium": {
      "Plan_913": _Premium2.Plan_913,
      "Plan_912": _Premium2.Plan_912
    },
    "Standard": {
      "Plan_910": _Standard2.Plan_910
    }
  },
  "hcf": {
    "PremiumPlus": {
      "Plan_732": _PremiumPlus.Plan_732,
      "Plan_733": _PremiumPlus.Plan_733
    },
    "Premium": {
      "Plan_730": _Premium3.Plan_730,
      "Plan_731": _Premium3.Plan_731
    }
  },
  "kogan": {
    "Indoor": {
      "Plan_853": _Indoor2.Plan_853,
      "Plan_854": _Indoor2.Plan_854,
      "Plan_855": _Indoor2.Plan_855
    },
    "Luxury": {
      "Plan_863": _Luxury.Plan_863,
      "Plan_864": _Luxury.Plan_864,
      "Plan_865": _Luxury.Plan_865,
      "Plan_866": _Luxury.Plan_866
    },
    "Primary": {
      "Plan_857": _Primary.Plan_857,
      "Plan_858": _Primary.Plan_858
    }
  },
  "medibank": {
    "Max": {
      "Plan_995": _Max.Plan_995,
      "Plan_996": _Max.Plan_996
    },
    "Plus": {
      "Plan_991": _Plus.Plan_991,
      "Plan_992": _Plus.Plan_992,
      "Plan_993": _Plus.Plan_993,
      "Plan_994": _Plus.Plan_994
    },
    "Protect": {
      "Plan_987": _Protect.Plan_987,
      "Plan_988": _Protect.Plan_988,
      "Plan_989": _Protect.Plan_989,
      "Plan_990": _Protect.Plan_990
    }
  },
  "greencross": {
    "Core": {
      "Plan_940": _Core.Plan_940,
      "Plan_941": _Core.Plan_941,
      "Plan_942": _Core.Plan_942,
      "Plan_943": _Core.Plan_943
    },
    "Total": {
      "Plan_944": _Total.Plan_944,
      "Plan_945": _Total.Plan_945
    }
  },
  "pia": {
    "Essentials": {
      "Plan_931": _Essentials.Plan_931
    },
    "EssentialsStepDown": {
      "Plan_932": _EssentialsStepDown.Plan_932
    },
    "Major": {
      "Plan_985": _Major.Plan_985
    },
    "Comprehensive": {
      "Plan_983": _Comprehensive2.Plan_983
    }
  },
  "prime": {
    "Imperial": {
      "Plan_895": _Imperial.Plan_895
    },
    "Regal": {
      "Plan_935": _Regal.Plan_935
    },
    "Sovereign": {
      "Plan_896": _Sovereign.Plan_896,
      "Plan_897": _Sovereign.Plan_897
    }
  },
  "rspca": {
    "General": {
      "Plan_937": _General.Plan_937
    },
    "UltimatePlus": {
      "Plan_938": _UltimatePlus.Plan_938,
      "Plan_939": _UltimatePlus.Plan_939
    },
    "Economy": {
      "Plan_903": _Economy.Plan_903
    },
    "Ultimate": {
      "Plan_904": _Ultimate2.Plan_904,
      "Plan_905": _Ultimate2.Plan_905
    }
  },
  "real": {
    "Classic": {
      "Plan_936": _Classic2.Plan_936
    },
    "Premium": {
      "Plan_900": _Premium4.Plan_900,
      "Plan_901": _Premium4.Plan_901
    },
    "Standard": {
      "Plan_899": _Standard3.Plan_899
    }
  },
  "bwm": {
    "Nose-To-Tail": {
      "Plan_1042": _NoseToTail.Plan_1042,
      "Plan_1037": _NoseToTail.Plan_1037,
      "Plan_1038": _NoseToTail.Plan_1038,
      "Plan_1039": _NoseToTail.Plan_1039,
      "Plan_1040": _NoseToTail.Plan_1040,
      "Plan_1044": _NoseToTail.Plan_1044,
      "Plan_1045": _NoseToTail.Plan_1045,
      "Plan_1046": _NoseToTail.Plan_1046,
      "Plan_1047": _NoseToTail.Plan_1047,
      "Plan_1048": _NoseToTail.Plan_1048,
      "Plan_1049": _NoseToTail.Plan_1049,
      "Plan_1050": _NoseToTail.Plan_1050
    }
  },
  "wow": {
    "Basic": {
      "Plan_947": _Basic5.Plan_947
    },
    "ComprehensivePlus": {
      "Plan_953": _ComprehensivePlus.Plan_953,
      "Plan_954": _ComprehensivePlus.Plan_954
    },
    "Comprehensive": {
      "Plan_951": _Comprehensive3.Plan_951,
      "Plan_952": _Comprehensive3.Plan_952
    },
    "Indoor": {
      "Plan_948": _Indoor3.Plan_948,
      "Plan_949": _Indoor3.Plan_949
    },
    "Standard": {
      "Plan_950": _Standard4.Plan_950
    }
  },
  "pinscom": {
    "Platinum": {
      "Plan_969": _Platinum2.Plan_969,
      "Plan_970": _Platinum2.Plan_970
    },
    "Bronze": {
      "Plan_971": _Bronze2.Plan_971,
      "Plan_972": _Bronze2.Plan_972,
      "Plan_973": _Bronze2.Plan_973,
      "Plan_974": _Bronze2.Plan_974
    },
    "Silver": {
      "Plan_964": _Silver.Plan_964,
      "Plan_965": _Silver.Plan_965,
      "Plan_966": _Silver.Plan_966,
      "Plan_967": _Silver.Plan_967
    },
    "Gold": {
      "Plan_975": _Gold2.Plan_975,
      "Plan_976": _Gold2.Plan_976,
      "Plan_977": _Gold2.Plan_977,
      "Plan_978": _Gold2.Plan_978
    }
  }
};
var _default = exports["default"] = {
  AllPublicProducts: AllPublicProducts
};